export enum ChartEntity {
  Chart = "Chart",
  ChartsFeature = "ChartsFeature",
  CutOffChartFeature = "CutOffChartFeature",
  ShutInMonthsChartFeature = "ShutInMonthsChartFeature",
  MovingAverageDaysChartFeature = "MovingAverageDaysChartFeature",
  ChartDataTableFeature = "ChartDataTableFeature",
  SourceFeature = "SourceFeature",
  TimeStepFeature = "TimeStepFeature",
  LassoFeature = "LassoFeature",
  NormalizationFeature = "NormalizationFeature",
  P10Feature = "P10Feature",
  P50Feature = "P50Feature",
  P90Feature = "P90Feature",
  AverageFeature = "AverageFeature",
  ScreenshotFeature = "Screenshot",
  ChartFocusFeature = "ChartFocusFeature",
  MultiProductFocusFeature = "MultiProductFocusFeature",
  PointOpacityFeature = "PointOpacityFeature",
  PointSizeFeature = "PointSizeFeature",
  LineSizeFeature = "LineSizeFeature",
  LineOpacityFeature = "LineOpacityFeature",
  HighlightedLineSizeFeature = "HighlightedLineSizeFeature",
  HighlightedLineOpacityFeature = "HighlightedLineOpacityFeature",
  ChartTypeParamFeature = "ChartTypeParamFeature",
  HistogramToggleFeature = "HistogramToggleFeature",
  JitterPlotToggleFeature = "JitterPlotToggleFeature",
  ViolinPlotToggleFeature = "ViolinPlotToggleFeature",
  DataRangeSelectFeature = "DataRangeSelectFeature",
  BestFitToggleFeature = "BestFitToggleFeature",
  CalculationMethodFeature = "CalculationMethodFeature",
  ChartFocusMidStreamFeature = "ChartFocusMidStreamFeature",
  PressureChartSettingsFeature = "PressureChartSettingsFeature",
  TotalFluidChartSettingsFeature = "TotalFluidChartSettingsFeature",
  LogAxisFeature = "LogAxisFeature",
  SlopeLineFeature = "SlopeLineFeature",
  XAxisSortFeature = "XAxisSortFeature",
  MultiProductFeature = "MultiProductFeature"
}

export enum MapEntity {
  Map = "Map"
}

export enum ThreeDViewEntity {
  ThreeDView = "3dView"
}

export const EntityType = {
  ...ChartEntity,
  ...MapEntity,
  ...ThreeDViewEntity
};
